import { formatMoney } from './novicell_shopify-utility.js';
import { populateUpsellDrawer, openUpsellDrawer } from './novicell_upsell-shared.js';

(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const productId = window.productId;
    const handle = window.productHandle;
    const moneyFormat = window.shopMoneyFormat;
    const shopCurrency = window.shopCurrency;
    const upsellContainer = document.getElementById("upsell-container");

    // Function to display the upsell product details on the page.
    function displayUpsellProduct(product) {

      window.upsellProduct = product;

      // Populate Drawer using shared logic
      populateUpsellDrawer(product, moneyFormat);

      // UPSELL PRODUCT PAGE BLOCK (Original logic)
      const upsellImage = document.getElementById("upsell-image")
      if (upsellImage) {
        upsellImage.src = product.featured_image || ""
        upsellImage.alt = product.title || ""
      }
      const upsellTitle = document.getElementById("upsell-title")
      if (upsellTitle) upsellTitle.textContent = product.title || ""
      const upsellVariant = document.getElementById("upsell-variant")
      if (upsellVariant) {
        if (product.variants && product.variants.length > 0)
          upsellVariant.textContent = product.variants[0].title || "Default"
        else upsellVariant.textContent = "Default"
      }
      const upsellPrice = document.getElementById("upsell-price");
      if (upsellPrice) {
        const formattedPrice = formatMoney(product.price, moneyFormat);
        upsellPrice.innerHTML = formattedPrice;
      }
      const upsellBlock = document.getElementById("upsell-container")
      if (upsellBlock) {
        upsellBlock.style.display = "block"
        upsellBlock.style.visibility = "visible"
      }
      const addToCartBtn = document.getElementById("add-to-cart-btn")
      if (addToCartBtn) {
        if (product.variants && product.variants.length > 0) {
          const variantId = product.variants[0].id
          addToCartBtn.setAttribute("data-product-id", variantId)
          addToCartBtn.style.display = "inline-block"
        } else {
          addToCartBtn.setAttribute("data-product-id", "")
          addToCartBtn.style.display = "none"
        }
      }

      const upsellLink = document.getElementById("product-upsell-link")
      if (upsellLink && product.handle) {
        upsellLink.setAttribute("href", `/products/${product.handle}`)
      }
    }

    // Hide the upsell block
    function hideUpsellBlock() {
      if (upsellContainer) {
        upsellContainer.style.display = "none";
        upsellContainer.style.visibility = "hidden";
      }
    }


    // Fetches product recommendations from Shopify's API.
    fetch(`/recommendations/products.json?product_id=${productId}&intent=complementary&limit=1`)
      .then((res) => res.json())
      .then((data) => {
        if (data.products && data.products.length > 0) {
          displayUpsellProduct(data.products[0]);
        } else {
          hideUpsellBlock();
        }
      })
      .catch((error) => {
        console.error("Error fetching complementary products:", error);
        hideUpsellBlock();
      });
  });


})();